import Request from './request'

const DeviceNetworkSettings = {
  getNetworkSettingsDevice (fid, callback) {
    Request.get('device-network-settings/' + fid).then(callback).catch(this.bad_answer)
  },
  updateNetworkSettingsDevice (fid, params, callback) {
    Request.put('device-network-settings/' + fid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },

}
export default DeviceNetworkSettings
